document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // CONFIGURATION
  // ============================================
  
  const BOUTIQUE_B_DOMAIN = 'eu-iconparis.com';
  
  // Configuration du produit à ajouter automatiquement (Protection livraison, etc.)
  const AUTO_ADD_PRODUCT = {
    enabled: true,  // Mettre false pour désactiver
    variantId: '56021583855947',  // Protection livraison offerte
    quantity: 1
  };
  
  // Configuration des bundles
  // Si le prix total du panier correspond à un de ces prix, on redirige vers le produit bundle
  const BUNDLE_VARIANTS = {
    '14.95': '56020232274251',  // Bundle 14.95€
    '29.95': '56020232307019'   // Bundle 29.95€
  };
  
  // Active le mode bundle (true = redirige vers bundle, false = redirige produits individuels)
  const USE_BUNDLE_MODE = false;
  
  // Masquer le referrer pour cacher l'origine de la redirection (optionnel)
  const HIDE_REFERRER = true;  // Mettre true pour activer
  
  // Mapping complet des variant IDs entre boutique A et boutique B
  const VARIANT_MAPPING = {
    // Bleu
    '56419349135733': '56019566625099',  // Bleu / 35
    '56419349168501': '56019566657867',  // Bleu / 36
    '56419349201269': '56019566690635',  // Bleu / 37
    '56419349234037': '56019566723403',  // Bleu / 38
    '56419349266805': '56019566756171',  // Bleu / 39
    '56419349299573': '56019566788939',  // Bleu / 40
    '56419349332341': '56019566821707',  // Bleu / 41
    '56419349365109': '56019566854475',  // Bleu / 42
    '56419349397877': '56019566887243',  // Bleu / 43
    '56419349430645': '56019566920011',  // Bleu / 44
    '56419349463413': '56019566952779',  // Bleu / 45
    
    // Rose
    '56419349496181': '56019566985547',  // Rose / 35
    '56419349528949': '56019567018315',  // Rose / 36
    '56419349561717': '56019567051083',  // Rose / 37
    '56419349594485': '56019567083851',  // Rose / 38
    '56419349627253': '56019567116619',  // Rose / 39
    '56419349660021': '56019567149387',  // Rose / 40
    '56419349692789': '56019567182155',  // Rose / 41
    '56419349725557': '56019567214923',  // Rose / 42
    '56419349758325': '56019567247691',  // Rose / 43
    '56419349791093': '56019567280459',  // Rose / 44
    '56419349823861': '56019567313227',  // Rose / 45
    
    // Noir
    '56419349856629': '56019567345995',  // Noir / 35
    '56419349889397': '56019567378763',  // Noir / 36
    '56419349922165': '56019567411531',  // Noir / 37
    '56419349954933': '56019567444299',  // Noir / 38
    '56419349987701': '56019567477067',  // Noir / 39
    '56419350020469': '56019567509835',  // Noir / 40
    '56419350053237': '56019567542603',  // Noir / 41
    '56419350086005': '56019567575371',  // Noir / 42
    '56419350118773': '56019567608139',  // Noir / 43
    '56419350151541': '56019567640907',  // Noir / 44
    '56419350184309': '56019567673675',  // Noir / 45
    
    // Gris
    '56419350217077': '56019567706443',  // Gris / 35
    '56419350249845': '56019567739211',  // Gris / 36
    '56419350282613': '56019567771979',  // Gris / 37
    '56419350315381': '56019567804747',  // Gris / 38
    '56419350348149': '56019567837515',  // Gris / 39
    '56419350380917': '56019567870283',  // Gris / 40
    '56419350413685': '56019567903051',  // Gris / 41
    '56419350446453': '56019567935819',  // Gris / 42
    '56419350479221': '56019567968587',  // Gris / 43
    '56419350511989': '56019568001355',  // Gris / 44
    '56419350544757': '56019568034123',  // Gris / 45
    
    // Blanc
    '56419350577525': '56019568066891',  // Blanc / 35
    '56419350610293': '56019568099659',  // Blanc / 36
    '56419350643061': '56019568132427',  // Blanc / 37
    '56419350675829': '56019568165195',  // Blanc / 38
    '56419350708597': '56019568197963',  // Blanc / 39
    '56419350741365': '56019568230731',  // Blanc / 40
    '56419350774133': '56019568263499',  // Blanc / 41
    '56419350806901': '56019568296267',  // Blanc / 42
    '56419350839669': '56019568329035',  // Blanc / 43
    '56419350872437': '56019568361803',  // Blanc / 44
    '56419350905205': '56019568394571'   // Blanc / 45
  };
  
  // ============================================
  // FONCTIONS PRINCIPALES
  // ============================================
  
  /**
   * Intercepte tous les boutons et liens de checkout
   */
  function interceptCheckout() {
    // Intercepter les boutons de type name="checkout"
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(button => {
      button.removeEventListener('click', handleCheckoutClick); // Éviter les doublons
      button.addEventListener('click', handleCheckoutClick);
    });
    
    // Intercepter les liens vers /checkout
    document.querySelectorAll('a[href*="/checkout"]').forEach(link => {
      link.removeEventListener('click', handleCheckoutClick);
      link.addEventListener('click', handleCheckoutClick);
    });
    
    // Intercepter les formulaires qui vont vers /cart avec checkout
    document.querySelectorAll('form[action="/cart"]').forEach(form => {
      form.removeEventListener('submit', handleFormSubmit);
      form.addEventListener('submit', handleFormSubmit);
    });
    
    // Intercepter aussi le bouton "Proceed to checkout" dans le drawer/popup de panier
    document.querySelectorAll('[href="/checkout"], .cart__checkout-button, .btn--checkout').forEach(element => {
      element.removeEventListener('click', handleCheckoutClick);
      element.addEventListener('click', handleCheckoutClick);
    });
  }
  
  /**
   * Gère le submit de formulaire
   */
  function handleFormSubmit(e) {
    const checkoutInput = e.target.querySelector('input[name="checkout"]');
    if (checkoutInput) {
      handleCheckoutClick(e);
    }
  }
  
  /**
   * Gère le clic sur checkout
   */
  async function handleCheckoutClick(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    console.log('🔄 Redirection vers boutique B en cours...');
    
    try {
      // Récupérer le panier actuel
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log('📦 Panier actuel:', cart);
      
      if (cart.items.length === 0) {
        alert('Votre panier est vide');
        return;
      }
      
      // Construire l'URL pour la boutique B
      const redirectUrl = buildBoutiqueB_URL(cart.items);
      
      console.log('🎯 Redirection vers:', redirectUrl);
      
      // Rediriger
      if (HIDE_REFERRER) {
        // Méthode 1 : Via iframe invisible (masque le referrer)
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = redirectUrl;
        document.body.appendChild(iframe);
        
        // Après un court délai, rediriger vraiment
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 100);
      } else {
        // Redirection normale (Shopify verra le referrer)
        window.location.href = redirectUrl;
      }
      
    } catch (error) {
      console.error('❌ Erreur lors de la redirection:', error);
      
      // En cas d'erreur, afficher un message et proposer le checkout normal
      const retry = confirm('Une erreur est survenue. Voulez-vous réessayer ou continuer avec le checkout normal ?');
      if (retry) {
        handleCheckoutClick(e);
      } else {
        window.location.href = '/checkout';
      }
    }
  }
  
  /**
   * Construit l'URL de redirection vers la boutique B
   */
  function buildBoutiqueB_URL(items) {
    
    // ============================================
    // MODE BUNDLE : Détection et redirection
    // ============================================
    if (USE_BUNDLE_MODE) {
      // Calculer le prix total du panier (après réductions Kaching)
      const cartTotal = items.reduce((sum, item) => sum + (item.final_line_price / 100), 0);
      const cartTotalFormatted = cartTotal.toFixed(2);
      
      console.log(`💰 Prix total du panier: ${cartTotalFormatted}€`);
      
      // Vérifier si ce prix correspond à un bundle
      if (BUNDLE_VARIANTS[cartTotalFormatted]) {
        const bundleVariantId = BUNDLE_VARIANTS[cartTotalFormatted];
        console.log(`🎁 Bundle détecté ! Redirection vers le variant bundle: ${bundleVariantId}`);
        
        // Construire l'URL avec le bundle et les paramètres de tracking
        return buildFinalURL(bundleVariantId, 1);
      } else {
        console.log(`⚠️ Prix ${cartTotalFormatted}€ ne correspond à aucun bundle configuré`);
        console.log(`📋 Bundles disponibles:`, BUNDLE_VARIANTS);
      }
    }
    
    // ============================================
    // MODE NORMAL : Mapping produit par produit
    // ============================================
    console.log('📦 Mode normal activé - mapping des produits individuels');
    
    // Mapper les variants et construire l'URL
    const mappedItems = items
      .map(item => {
        const variantIdString = item.variant_id.toString();
        const boutiqueB_VariantID = VARIANT_MAPPING[variantIdString];
        
        if (!boutiqueB_VariantID) {
          console.warn(`⚠️ Pas de mapping pour le variant ${variantIdString} (${item.product_title} - ${item.variant_title})`);
          return null;
        }
        
        console.log(`✅ Mapping trouvé: ${variantIdString} → ${boutiqueB_VariantID} (${item.variant_title})`);
        return `${boutiqueB_VariantID}:${item.quantity}`;
      })
      .filter(item => item !== null);
    
    if (mappedItems.length === 0) {
      throw new Error('Aucun produit mappé trouvé dans le panier');
    }
    
    // Ajouter le produit automatique si activé
    if (AUTO_ADD_PRODUCT.enabled) {
      console.log(`🎁 Ajout automatique du produit: ${AUTO_ADD_PRODUCT.variantId}`);
      mappedItems.push(`${AUTO_ADD_PRODUCT.variantId}:${AUTO_ADD_PRODUCT.quantity}`);
    }
    
    // Construire la chaîne pour l'URL
    const cartString = mappedItems.join(',');
    
    return buildFinalURL(cartString, null);
  }
  
  /**
   * Détecte la langue actuelle depuis l'URL
   */
  function detectLanguage() {
    const path = window.location.pathname;
    
    // Détecte le préfixe de langue (/es, /it, /fr, etc.)
    const langMatch = path.match(/^\/([a-z]{2})\//);
    
    if (langMatch) {
      return langMatch[1]; // Retourne 'es', 'it', 'fr', etc.
    }
    
    return null; // Pas de préfixe = langue par défaut
  }
  
  /**
   * Construit l'URL finale avec les paramètres de tracking
   */
  function buildFinalURL(cartString, quantity) {
    // Si quantity est fourni (mode bundle), formater avec :quantity
    if (quantity !== null && quantity !== undefined) {
      cartString = `${cartString}:${quantity}`;
    }
    
    // Détecter la langue actuelle
    const language = detectLanguage();
    
    // ============================================
    // TRACKING PARAMETERS - TRÈS IMPORTANT
    // ============================================
    // Capturer les paramètres de tracking depuis l'URL actuelle ou les cookies
    const urlParams = new URLSearchParams(window.location.search);
    const trackingParams = new URLSearchParams();
    
    // Liste des paramètres de tracking à transférer
    const trackingParameters = [
      'ttclid',      // TikTok Click ID
      'fbclid',      // Facebook Click ID
      'gclid',       // Google Click ID
      'msclkid',     // Microsoft Click ID
      'utm_source',  // UTM Source
      'utm_medium',  // UTM Medium
      'utm_campaign', // UTM Campaign
      'utm_content', // UTM Content
      'utm_term'     // UTM Term
    ];
    
    // Copier les paramètres de tracking s'ils existent
    trackingParameters.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        trackingParams.set(param, value);
        console.log(`📊 Paramètre de tracking capturé: ${param}=${value}`);
      }
    });
    
    // Vérifier aussi dans les cookies (certains pixels stockent le ttclid en cookie)
    const ttclidFromCookie = getCookie('ttclid');
    if (ttclidFromCookie && !trackingParams.has('ttclid')) {
      trackingParams.set('ttclid', ttclidFromCookie);
      console.log(`📊 TikTok Click ID trouvé dans cookie: ${ttclidFromCookie}`);
    }
    
    // Construire l'URL complète avec auto-redirect vers checkout + paramètres de tracking
    let finalUrl = `https://${BOUTIQUE_B_DOMAIN}`;
    
    // Ajouter le préfixe de langue si détecté
    if (language) {
      finalUrl += `/${language}`;
      console.log(`🌍 Langue détectée: ${language} - Redirection vers checkout ${language}`);
    }
    
    finalUrl += `/cart/${cartString}?checkout`;
    
    // Ajouter les paramètres de tracking
    if (trackingParams.toString()) {
      finalUrl += `&${trackingParams.toString()}`;
    }
    
    return finalUrl;
  }
  
  /**
   * Récupère un cookie par son nom
   */
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }
  
  // ============================================
  // INITIALISATION
  // ============================================
  
  console.log('✅ Script de redirection checkout chargé');
  
  // Initialiser l'interception
  interceptCheckout();
  
  // Observer les changements DOM pour les thèmes avec AJAX
  // (ex: quand le panier s'ouvre en popup/drawer)
  const observer = new MutationObserver(function(mutations) {
    interceptCheckout();
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  console.log('🔍 Observation des changements DOM activée');
});